import './styles.scss';

const Step = ({ num, stepData, bg }) => {
	return (
		<div className='step' style={{ backgroundColor: bg }}>
			<h1>{num}</h1>
			<div>
				<h4>{stepData.top}</h4>
				<p>{stepData.sub}</p>
			</div>
		</div>
	);
};

const Steps = ({ stepData }) => {
	return (
		<div className='steps' style={{ backgroundColor: stepData.bgColor }}>
			<div className='inner'>
				{stepData?.data?.map((step, index) => {
					return (
						<Step
							key={index}
							num={index + 1}
							stepData={step}
							bg={stepData.blockColor}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default Steps;
